import type { FeedbackType } from '@/shared/domain'
import { cn } from '@/shared/ui/cn'
import { FEEDBACK_TYPE_CONFIG_BY_VALUE } from './feedback-type-config'

export type FeedbackTypeIconProps = {
  type: FeedbackType
  className?: string
}

export function FeedbackTypeIcon({ type, className }: FeedbackTypeIconProps) {
  const Icon = FEEDBACK_TYPE_CONFIG_BY_VALUE[type].Icon
  return <Icon aria-hidden className={cn('size-4 text-muted-foreground', className)} />
}
